import { render, staticRenderFns } from "./DettaglioEvento.vue?vue&type=template&id=2f288824&scoped=true"
import script from "./DettaglioEvento.vue?vue&type=script&lang=js"
export * from "./DettaglioEvento.vue?vue&type=script&lang=js"
import style0 from "./DettaglioEvento.vue?vue&type=style&index=0&id=2f288824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f288824",
  null
  
)

export default component.exports